import React from 'react';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { BsArrowBarDown } from '@react-icons/all-files/bs/BsArrowBarDown';
import { BsArrowBarLeft } from '@react-icons/all-files/bs/BsArrowBarLeft';
import { BsArrowBarRight } from '@react-icons/all-files/bs/BsArrowBarRight';
import { BsArrowBarUp } from '@react-icons/all-files/bs/BsArrowBarUp';
import { NumberInputField } from '@bucketplace/commerce-admin-ui';

import { FormContent } from '@/components/FormContent';

import { Dimensions } from './types';

const INPUTS: Record<
keyof Dimensions,
{
  icon?: React.ReactNode,
  maxLength: number,
}> = {
  top: { icon: <BsArrowBarUp />, maxLength: 3 },
  left: { icon: <BsArrowBarLeft />, maxLength: 3 },
  bottom: { icon: <BsArrowBarDown />, maxLength: 3 },
  right: { icon: <BsArrowBarRight />, maxLength: 3 },
};

export function GutterField({
  label,
  name,
}: {
  label: string,
  name: string,
}) {
  return (
    <FormContent header={label} direction="VERTICAL">
      <GapWrapper>
        { Object.keys(INPUTS).map((_key) => {
          const key = _key as keyof Dimensions;

          return (
            <NumberInputField
              key={`${name}-${key}`}
              name={`${name}.${key}`}
              label={INPUTS[key].icon}
              maxLength={INPUTS[key].maxLength}
              direction="HORIZONTAL"
              width="100%"
              customCss={css`
                > div {
                  width: 100%;
                }
              `}
            />
          );
        }) }
      </GapWrapper>
    </FormContent>
  );
}

const GapWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 8px;
`;
